import { useEffect, useState } from "react";
import * as WarehouseService from "services/warehouseService";
import { message } from "antd";
import i18n from "constants/initLng";

const useGetGoodReceipt = (isTrigger = true) => {
  const [goodReceiptCode, setGoodReceiptCode] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetch = async () => {
      try {
        setLoading(true);
        const res = await WarehouseService.getGoodReceiptCode();
        const data = res.data;
        setGoodReceiptCode(data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        message.error(
          i18n.t(`item.warehousemanagement.errorCode.INVALID_GOOD_RECEIPT_CODE`)
        );
      }
    }
    
    if (isTrigger) {
      fetch();
    }
  }, [isTrigger]);

  return {
    goodReceiptCode,
    loading,
  }
};

export default useGetGoodReceipt;